import { toast } from "react-toastify";

export const genericError = () => {
  toast.error("Something went wrong");
};
